import { newModalFromString } from './modal';
// import Accordion from './accordion';

// Modal PrivacyPolicy
/*
$('body').on('click', '.js-linkModalPrivacyPolicyFull', function (e) {
    e.preventDefault();
    const htmlContent = $($(this).data('target')).html();
    // create and open confirmation modal
    const modalBigContent = newModalFromString(htmlContent, false);
    modalBigContent.setContent(document.querySelector('.js-ModalPrivacyPolicyFull').innerHTML);
    $('.tingle-modal').addClass('wrapperModal');
    modalBigContent.open();
    Accordion.setup($(modalBigContent.modalBoxContent).find('.accordion'));
    $(modalBigContent.modalBox)
        .find('.close')
        .on('click', function (e) {
            modalBigContent.close();
        });

    $('.js-inside-close-modal').on('click', function (e) {
        e.preventDefault();
        modalBigContent.close();
    });

    $('[data-dismiss="modalBigContent"]').on('click', function (e) {
        e.preventDefault();
        modalBigContent.close();
    });
});

// Modal PrivacyPolicy Regulation Loyalty
$('.js-linkModalPrivacyPolicyFullRegulation').on('click', function (e) {
    e.preventDefault();
    const htmlContent = $($(this).data('target')).html();
    // create and open confirmation modal
    const modalBigContent = newModalFromString(htmlContent, false);
    modalBigContent.setContent(document.querySelector('.js-ModalPrivacyPolicyFullRegulation').innerHTML);
    $('.tingle-modal').addClass('wrapperModal regulation');
    modalBigContent.open();
    $(modalBigContent.modalBox)
        .find('.close')
        .on('click', function (e) {
            modalBigContent.close();
        });

    $('.js-inside-close-modal').on('click', function (e) {
        e.preventDefault();
        modalBigContent.close();
    });

    $('[data-dismiss="modalBigContent"]').on('click', function (e) {
        e.preventDefault();
        modalBigContent.close();
    });
});
*/

function _modalOpenerHelper (selectorWithContent, wrapperClass) {
    const htmlContent = $($(this).data('target')).html();
    // create and open confirmation modal
    const modalBigContent = newModalFromString(htmlContent, false, [wrapperClass]);
    modalBigContent.setContent(document.querySelector(selectorWithContent).innerHTML);
    $('.tingle-modal').addClass('wrapperModal');
    modalBigContent.open();
    $(modalBigContent.modalBox)
        .find('.close')
        .on('click', function (e) {
            modalBigContent.close();
        });

    $('.js-inside-close-modal').on('click', function (e) {
        e.preventDefault();
        modalBigContent.close();
    });

    $('[data-dismiss="modalBigContent"]').on('click', function (e) {
        e.preventDefault();
        modalBigContent.close();
    });
}

function _modalOpenerHelperAjax (url) {
    if (!url) {
        console.error('Missing URL for AJAX call');
        return;
    }

    $.spinner().start();
    $.ajax(url).then(data => {
        $.spinner().stop();
        const modalBigContent = newModalFromString(data, false, ['registrationAddedModal']);
        $(modalBigContent.modal).addClass('wrapperModal');
        modalBigContent.open();

        $(modalBigContent.modalBox).find('.close').on('click', function (e) {
            modalBigContent.close();
        });

        $('.js-inside-close-modal').on('click', function (e) {
            e.preventDefault();
            modalBigContent.close();
        });

        $('[data-dismiss="modalBigContent"]').on('click', function (e) {
            e.preventDefault();
            modalBigContent.close();
        });
    }).fail(() => {
        $.spinner().stop();
    });
}

// Modal PrivacyPolicyShortMarketing
$('body').on('click', '.js-linkModalPrivacyPolicyMarketing', function (e) {
    e.preventDefault();
    _modalOpenerHelper('.js-ModalPrivacyPolicyMarketing', 'registrationAddedModal');
});

// Modal PrivacyPolicyShortProfiling
$('body').on('click', '.js-linkModalPrivacyPolicyProfiling', function (e) {
    e.preventDefault();
    _modalOpenerHelper('.js-ModalPrivacyPolicyProfiling', 'registrationAddedModal');
});

// Modal SaleCondition
$('body').on('click', '.js-linkModalSaleCondition', function (e) {
    e.preventDefault();
    _modalOpenerHelper('.js-ModalSaleCondition', 'registrationAddedModal');
});

// Modal UseCondition
$('body').on('click', '.js-linkModalUseCondition', function (e) {
    e.preventDefault();
    _modalOpenerHelper('.js-ModalUseCondition', 'registrationAddedModal');
});

// Modal Marketing and Profiling AJAX
$('body').on('click', '.js-linkModalPrivacyPolicyMarketingLogin, .js-linkModalPrivacyPolicyProfilingLogin', function (e) {
    e.preventDefault();
    let url = $(e.currentTarget).data('url');
    _modalOpenerHelperAjax(url);
});

$('.add-to-email').on('change', (e) => {
    const $policyPaymentParent = $(e.currentTarget).closest('.policy-promotion-payment');

    if (e.target.id.indexOf('add-to-email-list-yes') > -1 && e.target.checked) {
        $policyPaymentParent.find('.add-to-personalized-list').prop('disabled', false);
        $policyPaymentParent.find('.left-disabled-cell').removeClass('disabled ');
        $policyPaymentParent.find('.disable-link-privacy').removeClass('disabled ');
    } else {
        $policyPaymentParent.find('.add-to-personalized-list').prop('checked', false);
        $policyPaymentParent.find('.add-to-personalized-list').prop('disabled', true);
        $policyPaymentParent.find('.policy-payment').addClass('disabled');
        $policyPaymentParent.find('.disable-link-privacy').addClass('disabled ');
    }
});

// Toggle PayPal button based on the privacy consent
$('.policy-promotion-payment').on('change', '[name^="consTrattamento"]', (e) => {
    if ($('meta[http-equiv=content-language]').attr('content') === 'ru-RU') {
        const $payPalButtonWrapper = $(e.currentTarget).closest('.drawer').find('.js_paypal_button_on_billing_form');

        if ($payPalButtonWrapper.length) {
            $payPalButtonWrapper.toggleClass('disabled', $(e.currentTarget).val() !== 'true');
        }
    }
});
